import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import LruCache from './LruCache';
import { CACHE_SIZE_KILOBYTES, CACHE_MAX } from '../constants/loggingConstants';

var LoggingCache = /*#__PURE__*/function () {
  function LoggingCache() {
    _classCallCheck(this, LoggingCache);

    if (!LoggingCache.cacheInstance) {
      this._cache = new LruCache(CACHE_SIZE_KILOBYTES);
      LoggingCache.cacheInstance = this;
    }

    return LoggingCache.cacheInstance;
  }

  _createClass(LoggingCache, [{
    key: "setCacheSize",
    value: function setCacheSize(size) {
      this._cache[CACHE_MAX] = size;
    }
  }, {
    key: "getCache",
    value: function getCache() {
      return this._cache;
    }
  }]);

  return LoggingCache;
}();

var cacheInstance = new LoggingCache();
Object.freeze(cacheInstance);
export default cacheInstance;